export const MODULES = {
  DEPARTMENTS: "Departments",
  USERS: "Users",
  ROLES: "Roles",
  PERMISSIONS: "Permissions",
  MENUS: "Menus",
  SETTINGS: "Settings",
  LANGUAGES: "Languages",
  NEWS_CATEGORIES: "News categories",
  MISSION_VISION: "Mission and Vision",
  Tags: "Tags",
  NEWS: "News",
  PAGES: "Pages",
  FORUMS: "Forums",
  GALLERY_LIBRARY: "Gallery library",
  GOVERNORATE: "Governorate",
  REGIONAL_OFFICE: "Regional Offices",
  EVENT_TYPES: "Event Types",
  EVENTS: "Events",
  TRAINING_PROGRAM: "Training Programs",
  TRAINING_PROGRAM_APPLICATION: "Training Program Applications",
  JOURNALISM: "Journalisms",
  ORGANIZATION_CATEGORY: "Organization Category",
  ORGANIZATION_HIERARCHY: "Organization Hierarchy",
  JOURNAL_CATEGORY: "Journal Category",
  CALENDAR_TYPES: "Calendar Types",
  CALENDARS: "Calendars",
  INTERNATIONAL_DAYS: "International Days",
  NEWS_BAR: "News Bar",
  SURVEY: "Survey",
  WEBSITE_TYPE: "Website Type",
  RELATED_WEBSITE: "Related Website",
  PHOTO_ALBUM: "Photo Album",
  PHOTO: "Photo",
  PHOTO_CATEGORY: "Photo Catogry",
  VIDEO_LIBRARY: "Video Library",
  VIDEO_LIBRARY_CATEGORY: "Video Library Category",
  RADIO_LIBRARY: "Radio Library",
  RADIO_LIBRARY_CATEGORY: "Radio Library Category",
  SERVICES_TOOLS: "Services And Tools",
  TAGS: "Tags",
  EGYPT_STATISTICS_JOURNALS: "Egypt Statistics Journal",
  CAPMAS_HEAD: "Capmas Head",
  CAPMAS_HISTORY: "Capmas History",
  ORGANIZATIONAL_CHART: "Organizational Chart",
  LAW_REGULATION: "Law Regulation",
  USAGE_RIGHT_AND_TERMS: "Usage Right And Term",
  SECTOR: "Sector",
  CAPMAS_SECTORS: "Capmas Sectors",
  DEPARTMENT_USERS: "Department Users",
  SUBJECTS: "Subjects",
  PUBLICATIONS: "Publications",
  PUBLICATIONS_TYPE: "Publication Types",
  POPULATION: "Population",
  IMPORTANTPORTAL: "Important Portal",
  SURVEYCENSUSE: "Survey Censuse",
  DATAREQUEST: "Data Request",
  MICROFILM: "Micro Film Data",
  FOOTER: "Site Selection",
  PUBLICATION_NEWS: "Publication News",
  HAPPENING_NOW: "Happening Now",
  FILTERS: "Filters",
  INDICATORS: "Indicators",
  SELECTED_INDICATORS: "SelectedIndicator",
  SLIDERS: "Sliders",
  SUBSCRIPTION: "Subscription Types",
  PUBLICATION_DETAILS: "PublicationDetails",
  MEDIA_LIBRARY: "Media Library",
  COUNTRY: "Country",
  MEDIA_LIBRARY_CATEGORY: "Media Library Category",
  MAIN_VALUE: "Main Value",
  GOVERNORATE_POPULATIONS: "Governorate Populations",
  EGYPT_POPULATIONS: "Egypt Populations",
  PERIODICS: "Periodics",
  EVIDENCE_AND_CLASSIFICATIONS: "Evidence And Classifications",
  MEASURE_UNITS: "Measure Units",
  YEAR_TYPES: "Year Types",
  SERVICE_TYPE: "Service Type",
  AGENY_TYPE: "Agency Type",
  FILM_TYPE: "Film Type",
  INFOGRAPHIC: "Infographic",
  CONTACTUS: "Contact Us",
  SOCIAL_LINK: "Social Link",
  EMAIL_LISTS: "Email Lists",
  EMAIL_LIST_CATEGORIES: "Email List Categories",
  DASHBOARD: "Dashboard",
  STUDY_PERIOD: "StudyPeriod",
  TRAINING_REQUEST: "TrainingRequest",
  GENERIC_FILES: "GenericFiles",
  CHATBOT: "Chatbot",
};
